import {Reducer} from "redux";
import {CONNECT, DISCONNECT, GET_INSTANCE} from "../action_types/ioActionTypes";

/**
 * Reducer state
 */
interface IIOReducerState {
    readonly loggedIn: boolean,
    readonly socket: SocketIOClient.Socket | undefined,
}

/**
 * Initial reducer state
 * @type {{instanceID: undefined; passwordHash: undefined; socket: undefined}}
 */
const initialState: IIOReducerState = {
    loggedIn: false,
    socket: undefined,
};

/**
 * IO action reducers
 */
const IOReducer: Reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case CONNECT: {
            return {
                ...state,
                socket: action.socket
            }
        }

        case DISCONNECT: {
            return {
                ...state,
                loggedIn: false,
                socket: undefined
            }
        }

        case GET_INSTANCE: {
            return {
                ...state,
                loggedIn: true
            }
        }

        /**
         * Default reducer
         */
        default:
            return state;
    }
};

export default IOReducer;


// WEBPACK FOOTER //
// ./src/reducers/ioReducer.ts